/*
 * Copyright (C) 2018 Frontier Developments PLC.
 */

import store from '@/store';
import {NavigationGuard} from 'vue-router';
import {RawLocation, Route} from 'vue-router/types/router';
import {Vue} from 'vue-property-decorator';
import ApiException from '@/exceptions/ApiException';

/**
 * Item route route guard.
 *
 * Note: if the jwt token is not undefined or empty then it is presumed that the JWT is valid.
 *
 * @param to
 * @param from
 * @param next
 */
export const itemValidated: NavigationGuard = (
    to: Route,
    from: Route,
    next: (to?: RawLocation | false | ((vm: Vue) => any) | void) => void,
): void => {
    const itemId: string = to.params.itemId || '';
    if (0 === itemId.length) {
        next('/item');
        return;
    }

    // @todo check if item id is already the loaded item in vuex module

    // initialise item
    store.dispatch('ugcBuildModule/initialise', itemId).then(() => {
        next();
    }).catch((exception: Error | ApiException) => {
        // if we cannot find the item then we should remove it from vuex
        if (exception instanceof ApiException && 404 === exception.status) {
            store.dispatch('ugcItemModule/removeItem', itemId);
        }
        Vue.toastr.error(Vue.i18n.translate('item.not-found', {}) || '');
        next('/item');
    });
};
